import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FC } from 'react';

interface IProps {
	onClick: () => void;
	disabled?: boolean;
}

export const UpdateButton: FC<IProps> = ({ onClick, disabled = false }) => (
	<Button {...{ type: 'primary', onClick, disabled }}>
		<div className='flex items-center'>
			<EditOutlined style={{ marginRight: '0.3rem' }} /> Alterar
		</div>
	</Button>
);
